type AnyFunction = (...args: any[]) => any;

export function debounce<Fn extends AnyFunction>(fn: Fn, waitInMs: number) {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), waitInMs);
  };
}
